module.exports = __webpack_public_path__ + "img/CATree3.4b131fbb.jpg";